import { mapState, mapActions, mapGetters } from "vuex";
import CustomSideBarAppModal from "@/components/CustomSideBarAppModal";
import AppModal from "@/components/AppModal";
import AppIcon from "@/components/AppIcon";
import AppButton from "@/components/AppButton";
import TasksMixin from "@/mixins/TasksMixin.vue";
import { country_codes, country_codes_flipped } from "@/utils/countries";
export default {
  name: "AdvertisingAccountSideBar",
  emits: ["refresh"],
  mixins: [TasksMixin],
  components: {
    CustomSideBarAppModal,
    AppIcon,
    AppModal,
    AppButton
  },
  props: {
    account: {
      type: Object,
      default: () => ({})
    },
    account_type: {
      type: String,
      default: ""
    },
    profiles: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      confirmRemoveModal: false,
      removeLoading: false,
      removeId: null,
      accountRemoveTaskIdentifier: ""
    };
  },
  computed: {
    ...mapGetters(["getCountryFlag"]),
    ...mapState({
      me: state => state.auth.me,
      isOmnyWorkspace: state => state.workspace.isOmnyWorkspace,
      current_workspace: state => state.workspace.current_workspace
    })
  },
  mounted() {
    this.checkIfAnyPreviousAccountRemoveTaskIsRunning();
  },
  methods: {
    ...mapActions(["accountAuthorize", "accountRemove"]),
    onRemove(account_id) {
      this.removeId = account_id;
      this.confirmRemoveModal = true;
    },
    handleIdle() {
      this.removeLoading = false;
    },
    handleFailed() {
      this.removeLoading = false;
    },
    handleRunning(data) {
      this.removeLoading = true;
      this.checkTaskStatusPeriodically(data?.task_id);
    },
    handleFinished(data) {
      this.removeLoading = false;
      this.removeId = null;
      if (this.asyncUpdateInterval) {
        clearTimeout(this.asyncUpdateInterval);
        this.asyncUpdateInterval = null;
      }
      ;
      window.$bus.trigger("showSuccess", {
        visible: true,
        message: data.task_status + data.task_result.status,
        delay: 60 // Show alert less than 1 minute
      });
      this.$emit("refresh", {
        "account_id": this.account.account_id,
        "type": this.account_type
      });
    },
    checkIfAnyPreviousAccountRemoveTaskIsRunning() {
      for (const profile in this.profiles) {
        this.removeId = profile.account_id;
        this.accountRemoveTaskIdentifier = this.current_workspace.workspace_id + "_" + profile.account_id + "_" + "accounts_delete";
        this.getAsyncUpdate(this.accountRemoveTaskIdentifier);
        this.checkTaskStatusPeriodically(this.accountRemoveTaskIdentifier);
      }
    },
    async onRemoveConfirm() {
      this.confirmRemoveModal = false;
      this.removeLoading = true;
      this.accountRemoveTaskIdentifier = this.current_workspace.workspace_id + "_" + this.removeId + "_" + "accounts_delete";
      let account_remove_task = await this.accountRemove({
        seller_list: [{
          account_id: this.removeId.toString()
        }],
        task_identifier_omny: this.accountRemoveTaskIdentifier,
        workspace_id: this.current_workspace.workspace_id.toString()
      });
      this.getAsyncUpdate(account_remove_task.task_id);
      this.checkTaskStatusPeriodically(account_remove_task.task_id);
    },
    async onConnect() {
      const data = {
        region: this.account.region,
        account_provider: "Amazon Advertising",
        workspace_id: this.account.workspace_id,
        amz_sp_api_seller_id: this.account.selling_partner_id,
        // country: country_codes[this.account.country],
        account_type: this.account_type
      };
      this.loading = true;
      await this.accountAuthorize(data);
      this.loading = false;
    },
    flipCountry(country) {
      return country_codes_flipped[country];
    }
  }
};